import React from "react";
import { ScaleLoader } from "react-spinners";

const Loading = () => {
  return (
    <div className="p-6 min-h-page">
      <ScaleLoader color="#f0505f" />
    </div>
  );
};

export default Loading;
